__turbopack_context__.v({
  "signupDisabledContent": "signup-disabled-module-sass-module__LJJ3AW__signupDisabledContent",
  "signupDisabledHeader": "signup-disabled-module-sass-module__LJJ3AW__signupDisabledHeader",
});
